// fill-blanks-replace.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'fillBlanksReplace'
})
export class FillBlanksReplacePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(
    text: string,
    inputs: string[],
    isReviewMode: boolean,
    correctAnswers: string[]
  ): SafeHtml {
    if (!text) return '';

    // Replace placeholders with input fields
    let result = text.replace(/\{(\d+)\}/g, (match, index) => {
      const i = parseInt(index, 10);
      const value = inputs[i] || '';
      const correctAnswer = correctAnswers[i] || '';
      const isCorrect = value.toLowerCase() === correctAnswer.toLowerCase();
      const isIncorrect = value && !isCorrect;

      let classes = 'blank-input form-control';
      if (isReviewMode) {
        if (isCorrect) {
          classes += ' correct-answer';
        } else if (isIncorrect) {
          classes += ' incorrect-answer';
        }
      }

      let html = `<span class="blank-input-container">
        <input type="text" class="${classes}" 
               value="${value}" 
               ${isReviewMode ? 'disabled' : ''} 
               placeholder="________">`;

      // Add correct answer hint in review mode
      if (isReviewMode && isIncorrect) {
        html += `<span class="correct-answer-hint">${correctAnswer}</span>`;
      }

      html += '</span>';

      return html;
    });

    // Return sanitized HTML
    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
